const BlankChartingCompetency = () => <div className="u-els-display-none">Competencies Placeholder</div>;

BlankChartingCompetency.displayName = 'BlankChartingCompetency';
export default BlankChartingCompetency;
